var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLibraryFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(.99989 .5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.8801096 18.5000004h-11.75999998-.00000006c-1.2329 0-2.26522-.9342254-2.388-2.1610004l-.72-7.2.00000003.00000029c-.131996-1.31889.830175-2.49507 2.14907-2.62707.0793954-.00794597.159138-.0119299.23893-.0119299h13.20000001.0000001c1.32548 0 2.39993 1.07459 2.39993 2.40007 0 .0797921-.0039839.159534-.0119299.23893l-.72 7.20000001v.0000002c-.122777 1.22677-1.1551 2.1609998-2.388 2.1609998z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.00011 3.5h12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.00011.5h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.50011 10.25h5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-2-2h24v24h-24z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryFolder);
export default __webpack_public_path__ + "static/media/library-folder.b73bbb8f97c7681689a12337692464a7.svg";
export { ForwardRef as ReactComponent };